export const SLICE_NAME = 'metalCost';
